import React from 'react';
import PropTypes from 'prop-types';
import { ContactFormatter } from './ContactFormatter';

/**
 * HtmlFormatter is a formatter which displays html content, but
 * returns a dash for empty or null values.
 */
export const EmailContactListFormatter = ({ value, remove, ...rest }) => {
  const { big } = rest;

  const styles = {
    input: {
      height: '100%',
      minHeight: big ? 250 : 34,
      display: 'flex',
    },
  };

  if (!value || value.size === 0) {
    return <div className="form-control" style={styles.input} />;
  }

  return (
    <div className="form-control" style={styles.input}>
      {value.map((val, index) => (
        <ContactFormatter key={index} remove={remove} value={val} />
      ))}
    </div>
  );
};

EmailContactListFormatter.propTypes = {
  value: PropTypes.array,
};
